export default "__VITE_ASSET__004d494d__"